// src/pages/Login.js
import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, Alert } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import styles from "./login.module.css"; // Import CSS Module
import { auth, db } from "../../firebase/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";

const { Title } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setError("");

    try {
      // Sign in with Firebase Authentication
      const userCredential = await signInWithEmailAndPassword(
        auth,
        values.email,
        values.password
      );

      // Check if user exists in admins collection
      const adminsRef = collection(db, "admins");
      const q = query(adminsRef, where("email", "==", values.email));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        // If user is not in admins collection
        await auth.signOut(); // Sign out the user
        setError("Not authorized. Access restricted to administrators only.");
        return;
      }

      // If user is an admin, navigate to dashboard
      navigate("/dashboard");
      
    } catch (err) {
      setError(err.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <Card className={styles.loginCard}>
        <Title level={3} className={styles.loginTitle}>
          Login
        </Title>
        {error && (
          <Alert
            className={styles.errorAlert}
            message={error}
            type="error"
            showIcon
          />
        )}
        <Form
          name="login_form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          layout="vertical"
          className={styles.loginForm}
        >
          {/* Email Field */}
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please input your email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
            className={styles.loginFormItem}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Enter your email"
              size="large"
            />
          </Form.Item>

          {/* Password Field */}
          <Form.Item
            label="Password"
            name="password"
            rules={[
              { required: true, message: "Please input your password!" },
              { min: 6, message: "Password must be at least 6 characters!" },
            ]}
            className={styles.loginFormItem}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter your password"
              size="large"
            />
          </Form.Item>

          {/* Submit Button */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className={styles.loginButton}
              loading={loading}
              size="large"
            >
              Login
            </Button>
          </Form.Item>

          {/* Forgot Password Link */}
          <div className={styles.forgotPasswordLink}>
            <a href="/forgot-password">Forgot Password?</a>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login;